import { Typography } from '@mui/material';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';

import {
  ItemRoot, NavbarLink, NavbarWrapper, NavElement,
} from 'components/_Navbar/NavigationTabs/index.styled';

import { useAppSelector } from 'hooks/useRedux';
import { userRoleSelector } from 'store/user/selectors';

import BusinessmanIcon from 'assets/icons/BusinessmanIcon';
import NewsIcon from 'assets/icons/NewsIcon';
import ReceiptIcon from 'assets/icons/ReceiptIcon';
import { CLIENT_DETAILS_ROUTE, CLIENTS_ROUTE, NEWS_ROUTE } from 'constants/clientRoutes';
import { isAdmin } from 'utils/permissions';

const NavigationTabs = (): ReactElement => {
  const intl = useIntl();
  const userRole = useAppSelector(userRoleSelector);

  return (
    <NavbarWrapper>
      <NavbarLink id="link-news" to={NEWS_ROUTE}>
        {({ isActive }): ReactElement => (
          <ItemRoot id="div-news">
            <NavElement isActive={isActive}>
              <NewsIcon />
              <Typography id="text-news" variant="body2">
                {intl.formatMessage({ id: 'navigation.news' })}
              </Typography>
            </NavElement>
          </ItemRoot>
        )}
      </NavbarLink>
      {isAdmin(userRole) && userRole && (
        <NavbarLink id="link-clients" to={CLIENTS_ROUTE}>
          {({ isActive }): ReactElement => (
            <ItemRoot id="div-clients">
              <NavElement isActive={isActive}>
                <BusinessmanIcon />
                <Typography id="text-clients" variant="body2">
                  {intl.formatMessage({ id: 'navigation.clients' })}
                </Typography>
              </NavElement>
            </ItemRoot>
          )}
        </NavbarLink>
      )}
      {!isAdmin(userRole) && userRole && (
        <NavbarLink id="link-myBills" to={CLIENT_DETAILS_ROUTE}>
          {({ isActive }): ReactElement => (
            <ItemRoot id="div-myBills">
              <NavElement isActive={isActive}>
                <ReceiptIcon />
                <Typography id="text-myBills" variant="body2">
                  {intl.formatMessage({ id: 'navigation.infoAndDocuments' })}
                </Typography>
              </NavElement>
            </ItemRoot>
          )}
        </NavbarLink>
      )}
    </NavbarWrapper>
  );
};

export default NavigationTabs;
